import { InputLabel } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';
import { useTranslation } from 'react-i18next';

const BillingFrequencySelect = ({ value, onChange, error, helperText, hideAll = false, ...selectProps }) => {
  const { t } = useTranslation();

  const handleChange = event => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl error={error}>
      <InputLabel>{t('billing.billingFrequency', 'Billing Frequency')}</InputLabel>
      <Select
        {...selectProps}
        label={t('billing.billingFrequency', 'Billing Frequency')}
        value={value != null && value != undefined ? value : 'all'}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': t('billing.selectBillingFrequency', 'Select Billing Frequency') }}
        sx={{ minWidth: '140px' }}
      >
        <MenuItem value="" disabled>
          {t('billing.selectBillingFrequency', 'Select Billing Frequency')}
        </MenuItem>
        {!hideAll && <MenuItem value="all">{t('billing.all', 'All')}</MenuItem>}
        <MenuItem value="none">{t('billing.none', 'None')}</MenuItem>
        <MenuItem value="month">{t('billing.monthly', 'Monthly')}</MenuItem>
        <MenuItem value="quarter">{t('billing.quarterly', 'Quarterly')}</MenuItem>
        <MenuItem value="semiannual">{t('billing.semiAnnually', 'Semi-Annually')}</MenuItem>
        <MenuItem value="annual">{t('billing.annually', 'Annually')}</MenuItem>
        <MenuItem value="prepaid">{t('billing.prepaid', 'Prepaid')}</MenuItem>
        <MenuItem value="trial">{t('billing.trial', 'Trial')}</MenuItem>
        <MenuItem value="demo">{t('billing.demo', 'Demo')}</MenuItem>
        <MenuItem value="internal">{t('billing.internal', 'Internal')}</MenuItem>
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default BillingFrequencySelect;
